// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__37g7o","footer":"ModalFilter_footer__25jHD"};